import { createUseContext } from '../../utils/create-use-context/create-use-context.js';

const [MenuProvider, useMenuContext] = createUseContext(null);

export { MenuProvider, useMenuContext };
//# sourceMappingURL=Menu.context.js.map
